import { toTitleCase } from 'common';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { useAppSettings } from '../../contexts';

const defaultTitle = 'Portal';

type RouteElementProps = {
  Element: React.FC;
  title?: string;
  children?: React.ReactNode;
};

const RouteElement = ({ children, Element, title }: RouteElementProps) => {
  const { appSettings } = useAppSettings();

  const elementName =
    Element.displayName || (Element.name && toTitleCase(Element.name));
  const pageTitle = title || elementName || defaultTitle;

  return (
    <>
      <Helmet>
        <title>{`${pageTitle} | ${appSettings.name}`}</title>
        <meta property="og:title" content={pageTitle} />
      </Helmet>

      <Suspense fallback={<>...</>}>
        <Element />
        {children}
      </Suspense>
    </>
  );
};

export default RouteElement;
